import { PROFILE_TIERS, type ProfileTier } from '~/constants/profileTier';
import type { StoreStateProps } from '~/store/types';

// Derive profile tier from global state; default to T0 when unset.
export const getCurrentProfileTier = (state?: StoreStateProps): ProfileTier => {
    const tier = state?.customer?.details?.profileTier as ProfileTier | undefined;
    return tier && tier in PROFILE_TIERS ? tier : PROFILE_TIERS.T0;
};
